<template>
  <div class="membership-bg">
    <div style=" padding: 32px; border-radius: 20px;">
      <!-- 顶部统计卡片区 -->
      <div class="stats-row">
        <div class="stat-card stat-flex">
          <div class="stat-icon-bg">
            <img src="image/time.png" class="stat-icon-img" alt="总学习时长">
          </div>
          <div class="stat-content">
            <div class="stat-value">24小时</div>
            <div class="stat-label">总学习时长</div>
          </div>
        </div>
        <div class="stat-card stat-flex">
          <div class="stat-icon-bg">
            <img src="image/course.png" class="stat-icon-img" alt="已学课程">
          </div>
          <div class="stat-content">
            <div class="stat-value">12</div>
            <div class="stat-label">已学课程</div>
          </div>
        </div>
        <div class="stat-card stat-flex">
          <div class="stat-icon-bg">
            <img src="image/percent.png" class="stat-icon-img" alt="完成率">
          </div>
          <div class="stat-content">
            <div class="stat-value">80%</div>
            <div class="stat-label">完成率</div>
          </div>
        </div>
      </div>

      <!-- 下方三栏内容区 -->
      <div class="main-content-row">
        <!-- 学习进度 -->
        <div class="main-card progress-card">
          <div class="card-title-row progress-title-row">
            <span class="main-card-title progress-title">学习进度</span>
            <span class="progress-range" @click="showTimeDropdown = !showTimeDropdown">
              {{ currentTimeRange }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown v-if="showTimeDropdown" trigger="click" @command="handleTimeChange" @visible-change="showTimeDropdown = $event">
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="week">本周</el-dropdown-item>
                <el-dropdown-item command="month">本月</el-dropdown-item>
                <el-dropdown-item command="year">今年</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="progress-circle-wrapper">
            <el-progress type="circle" :percentage="80" :width="180" stroke-width="16" color="#2EA2FA">
              <div class="progress-center-text">
                <div class="progress-percent">80%</div>
                <div class="progress-desc">完成率</div>
              </div>
            </el-progress>
          </div>
          <div class="progress-stats-row">
            <div class="progress-stat">
              <div class="stat-num">18</div>
              <div class="stat-label progress-stat-label">已完成课时</div>
            </div>
            <div class="progress-stat">
              <div class="stat-num">24</div>
              <div class="stat-label progress-stat-label">总课时</div>
            </div>
            <div class="progress-stat">
              <div class="stat-num">15</div>
              <div class="stat-label progress-stat-label">学习天数</div>
            </div>
          </div>
        </div>

        <!-- 最近学习 -->
        <div class="main-card recent-card">
          <div class="card-title-row recent-title-row">
            <span class="main-card-title recent-title">最近学习</span>
            <span class="recent-more" @click="viewAllLearningHistory">查看全部 ></span>
          </div>
          <div class="recent-list">
            <div v-for="course in recentCourses" :key="course.id" class="recent-item">
              <img :src="course.image" :alt="course.name" class="recent-img">
              <div class="recent-info">
                <div class="recent-title-row">
                  <span class="recent-title-text">{{ course.name }}</span>
                  <el-button type="primary" size="mini" class="recent-btn" @click="continueLearning(course)">继续学习</el-button>
                </div>
                <div class="recent-meta">最近学习时间：{{ course.lastStudyTime }}</div>
                <div class="recent-progress-row">
                  <el-progress :percentage="course.progress" :show-text="false" :stroke-width="6" color="#2EA2FA"></el-progress>
                </div>
                <div class="recent-progress-text" style="position: absolute; right: 18px; bottom: 10px; font-size: 13px; color: #2EA2FA;">已完成{{ course.progress }}%</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 推荐课程 -->
        <div class="main-card recommend-card">
          <div class="card-title-row recommend-title-row">
            <span class="main-card-title recommend-title">推荐课程</span>
            <span class="recommend-more" @click="viewAllRecommendedCourses">更多课程 ></span>
          </div>
          <div class="recommend-list">
            <div v-for="course in recommendedCourses" :key="course.id" class="recommend-item">
              <img :src="course.image" :alt="course.name" class="recommend-img">
              <div class="recommend-info">
                <div class="recommend-title-row">
                  <span class="recommend-title-text">{{ course.name }}</span>
                  <el-button type="primary" size="mini" class="recommend-btn">开始学习</el-button>
                </div>
                <div class="recommend-desc">{{ course.description }}</div>
                <div class="recommend-status">未开始</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Membership',
  data() {
    return {
      currentTimeRange: '本周',
      showTimeDropdown: false,
      recentCourses: [
        {
          id: 1,
          name: '玩转未来',
          image: '/image/wl.png',
          lastStudyTime: '最后学习时间：2024-01-15',
          progress: 60
        },
        {
          id: 2,
          name: '激光切割课程',
          image: '/image/jg.png',
          lastStudyTime: '最后学习时间：2024-01-14',
          progress: 30
        }
        ,
        {
          id: 3,
          name: 'STEAM课程',
          image: '/image/steam.png',
          lastStudyTime: '最后学习时间：2024-01-14',
          progress: 50
        }
      ],
      recommendedCourses: [
        {
          id: 1,
          name: '小小创客掌控板',
          image: '/image/zkb.png',
          description: '学习3D建模的基本概念和技巧'
        },
        {
          id: 2,
          name: '科学创客教育实战',
          image: '/image/kx.png',
          description: '深入学习工程制图的高级技巧'
        },
        {
          id: 3,
          name: '孩子编程启蒙书',
          image: '/image/qm.png',
          description: '学习实际项目中的CAD应用技巧'
        }
      ]
    }
  },
  methods: {
    continueLearning(course) {
      console.log('继续学习课程:', course.name);
      // 实现继续学习的逻辑
      this.$router.push({
        name: 'CourseDetail',
        params: { 
          courseId: course.id 
        }
      });
    },
    handleTimeChange(command) {
      this.currentTimeRange = {
        'week': '本周',
        'month': '本月',
        'year': '今年'
      }[command];
      // 实现时间范围切换的逻辑
    },
    viewAllLearningHistory() {
      this.$router.push({
        name: 'LearningHistory',
        query: {
          from: 'membership'
        }
      });
    },
    viewAllRecommendedCourses() {
      this.$router.push({
        name: 'RecommendedCourses',
        query: {
          from: 'membership'
        }
      });
    }
  }
}
</script>

<style scoped>
.membership-bg {
  min-height: 100vh;
  background: #eaf6fe;
  padding: 32px;
  max-width: 1000px;
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 16px;
}
.stats-row {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 40px;
  background: #fff;
  padding: 20px 40px;
  border-radius: 16px;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  margin-top: -30px;
  margin-left: -40px;
}
@media (max-width: 1024px) {
  .stats-row {
    margin-top: 32px;
    
  }
}
.stat-card {
  background: #2EA2FA;
  color: #fff;
  border-radius: 16px;
  width: 320px;
  min-height: 90px;
  box-shadow: 0 2px 12px 0 rgba(46,162,250,0.12);
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: relative;
  width: 90%;
  min-width: 0;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .stat-card {
    width: 100%;
    padding: 0 6px;
  }
}
.stat-flex {
  flex-direction: row;
  justify-content: flex-start;
}
.stat-icon-bg {
  background: #fff;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  box-shadow: 0 2px 8px 0 rgba(46,162,250,0.10);
}
@media (max-width: 1024px) {
  .stat-icon-bg {
    width: 24px;
    height: 24px;
  }
}
.stat-icon-img {
  width: 32px;
  height: 32px;
}
@media (max-width: 1024px) {
  .stat-icon-img {
    width: 24px;
    height: 24px;
  }
}
.stat-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.stat-value {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 2px;
  color: #fff;
  text-align: justify;
}
@media (max-width: 1024px) {
  .stat-value {
    font-size: 12px;
  }
}
.stat-label {
  font-size: 11px !important;
  color: #ffffff !important;
  text-align: justify;
  opacity: 0.98;
}
@media (max-width: 1024px) {
  .stat-label {
    font-size: 9px !important;
  }
}
.main-content-row {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 32px;
}
.main-card,
.progress-card,
.recent-card,
.recommend-card {
  width: calc(100% / 3 - 70px);
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  text-align: justify;
}
.main-card, .progress-card, .recent-card, .recommend-card {
  font-size: 90%;
  padding: 18px 12px 14px 12px;
}
.stats-row, .progress-stats-row {
  gap: 12px;
}
.stat-card {
  padding: 0 12px;
  width: 80%;
}
.stat-icon-bg, .stat-icon-img {
  width: 36px;
  height: 36px;
}
.stat-value { font-size: 16px; }
.stat-label { font-size: 12px !important; }
.progress-title { font-size: 15px; }
.progress-percent { font-size: 22px; }
.progress-desc { font-size: 12px; }
.recent-img, .recommend-img { width: 48px; height: 48px; }
.recent-title, .recommend-title { font-size: 15px; }
.recent-item, .recommend-item { padding: 8px 8px; font-size: 13px; }
.main-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px 0 rgba(46,162,250,0.08);
  padding: 32px 24px 24px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.progress-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 16px 0 rgba(46,162,250,0.08);
  padding: 36px 18px 28px 18px;
  max-width: 340px;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.progress-title-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.progress-title {
  font-size: 18px;
  font-weight: 600;
  color: #222;
}
.progress-range {
  font-size: 14px;
  color: #2EA2FA;
  cursor: pointer;
  margin-left: auto;
  user-select: none;
  display: flex;
  align-items: center;
}
.progress-circle-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 18px;
}
.progress-center-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.progress-percent {
  font-size: 32px;
  font-weight: bold;
  color: #222;
  margin-bottom: 2px;
}
.progress-desc {
  font-size: 16px;
  color: #888;
}
.progress-stats-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
  width: 100%;
  padding: 0 8px;
}
.progress-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
}
.stat-num {
  font-size: 20px;
  font-weight: bold;
  color: #222;
}
.progress-stat-label {
  font-size: 13px;
  color: #666 !important;
  margin-top: 4px;
  opacity: 1 !important;
  font-weight: 400;
}
.recent-card, .recommend-card {
  max-width: 370px;
}
.recent-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.recent-item {
  background: #f8fbff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 12px 14px;
  box-shadow: 0 1px 6px 0 rgba(46,162,250,0.06);
  min-height: 70px;
  position: relative;
}
.recent-img {
  width: 84px;
  height: 84px;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 2px 8px 0 rgba(46,162,250,0.09);
}
.recent-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.recent-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.recent-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
}
.recent-meta {
  font-size: 13px;
  color: #888;
  white-space: nowrap;
}
.recent-progress-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.recent-progress-text {
  position: absolute;
  right: 18px;
  bottom: -10px;
  
  font-size: 13px;
  color: #2EA2FA;
  margin-left: 4px;
  margin-top: 10px;
}
.recommend-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.recommend-item {
  display: flex;
  background: #F8FBFF;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(46,162,250,0.06);
  padding: 14px 12px;
  align-items: center;
  gap: 16px;
}
.recommend-img {
  width: 84px;
  height: 84px;
  border-radius: 8px;
  object-fit: contain;
  box-shadow: 0 2px 8px 0 rgba(46,162,250,0.09);
}
.recommend-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.recommend-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.recommend-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
}
.recommend-desc {
  font-size: 13px;
  color: #888;
  margin: 3px 0 2px 0;
}
.recommend-status {
  font-size: 12px;
  color: #b0b8c6;
  margin-top: 2px;
}

/* 进一步缩小最近学习、推荐课程板块内的图片、按钮、标题、描述等元素，优化紧凑布局 */
.recent-card, .recommend-card {
  padding: 10px 6px 10px 6px;
}
.recent-item, .recommend-item {
  padding: 30px 6px;
  gap: 6px;
  min-height: 54px;
}
.recent-img, .recommend-img {
  width: 36px;
  height: 36px;
  margin-right: 8px;
}
.recent-info, .recommend-info {
  gap: 2px;
}
.recent-title-row, .recommend-title-row {
  margin-bottom: 8px;
  font-size: 14px;
}
.recent-title, .recommend-title {
  font-size: 13px;
  font-weight: 500;
}
.recent-btn, .recommend-btn {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 8px;
}
.recent-meta, .recommend-desc {
  font-size: 11px;
  margin: 1px 0 2px 0;
}
.recommend-list, .recent-list {
  gap: 10px;
}

/* 响应式适配笔记本屏幕，保持原结构和样式不变，仅添加媒体查询 */
@media (max-width: 1024px) {
  .main-content-row {
    flex-direction: column;
    gap: 8px;
  }
  .main-card,
  .progress-card,
  .recent-card,
  .recommend-card {
    width: 100%;
    font-size: 100%;
    padding: 14px 8px 10px 8px;
  }
  .stat-card {
    width: 100%;
  }
  .recent-img, .recommend-img {
    width: 28px;
    height: 28px;
  }
  .recent-btn, .recommend-btn {
    font-size: 11px;
    padding: 1px 6px;
  }
}

/* 每个主板块距离顶部 50px */
.main-content-row > .main-card,
.main-content-row > .progress-card,
.main-content-row > .recent-card,
.main-content-row > .recommend-card {
  margin-top: 50px;
}
@media (max-width: 1024px) {
  .main-content-row > .main-card,
  .main-content-row > .progress-card,
  .main-content-row > .recent-card,
  .main-content-row > .recommend-card {
    margin-top: 32px;
  }
}
</style>
